import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { GROWTHBOOK_FEATURE_FLAGS } from '@web-app/constants/growthbook';

export const useLingoEnabled = (): boolean =>
  useFeatureIsOn(GROWTHBOOK_FEATURE_FLAGS.LINGO_ENABLED);
